import { render, staticRenderFns } from "./PrintPage.vue?vue&type=template&id=32798852&scoped=true"
import script from "./PrintPage.vue?vue&type=script&lang=js"
export * from "./PrintPage.vue?vue&type=script&lang=js"
import style0 from "./PrintPage.vue?vue&type=style&index=0&id=32798852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32798852",
  null
  
)

export default component.exports